import * as actionTypes from '../action-types';
import { getMsgNum } from '@/api/api';
// export const updateMsgNum=(msgNum)=>{
//   return{
//     type:actionTypes.MSG_NUM_UPDATE,
//     msgNum:msgNum
//   }
// }

export const updateMsgNum = () => {
    return async dispatch => {
        getMsgNum({}, res => {
            if (res.statusCode === 1000) {
                dispatch({
                    type: actionTypes.MSG_NUM_UPDATE,
                    msgNum: res.msgNum,
                });
            };
        }, err => {
            console.log(err)
        })
    }
}